import { render } from "./TokensView.vue?vue&type=template&id=7cc49ea2"
import script from "./TokensView.vue?vue&type=script&lang=js"
export * from "./TokensView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__